import styles from './index.module.scss';
import ProListpageTop from '../components/ProListpageTop'
import ProjectListItem from '../../components/ProjectListItem'
import { useState, useEffect, useContext, useMemo } from 'react';
import { Pagination, message, Tabs } from 'antd';
import Utils from '@utils/utils'
import API, { commonApiInvoker } from '@api/api.js';
import { ProjectContext } from '../../hooks/ProjectContext'
import PSAIModal from '@PSAIComponents/PSAIModal';
import { AppContext } from '@utils/AppContext';


const ProjectListPage = () => {
    const {
        proOrder,
        proSortField,
        proFunction,
        projectName,
        tabKey, setTabKey
    } = useContext(ProjectContext)

    const { proSidebarValue, globalOrgInfo, globalUser, member, setMember } = useContext(AppContext);

    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState()
    const [list, setList] = useState([])
    const [total, setTotal] = useState()
    const [isSelected, setIsSelected] = useState(false) // 是否选择
    const [selectedList, setSelectedList] = useState([]) // 已选列表
    const [downLoading, setDownLoading] = useState(false)
    const [bookCover, setBookCover] = useState() //收藏封面
    const [isFirstLoad, setIsFirstLoad] = useState(true);


    const items = [
        {
            key: '1',
            label: '个人项目',
        },
        {
            key: '2',
            label: '团队项目',
        }
    ]

    useEffect(() => {
        setPageIndex(1)
        if (tabKey == '1') {
            setMember(globalUser?.id)
        } else {
            setMember('team')
        }
    }, [tabKey])

    const tabChange = key => {
        setTabKey(key)
    }
    useEffect(() => {
        if (!globalUser?.id) return
        if (tabKey == '1') {
            setMember(globalUser?.id)
        }
    }, [globalUser?.id, tabKey])
    // Tab----


    const onChange = pageNumber => {
        sessionStorage.setItem('projectListPageIndex', pageNumber)
        setPageIndex(pageNumber)
    };

    useEffect(() => {
        setTimeout(() => {
            let index = sessionStorage.getItem('projectListPageIndex')
            if (index) setPageIndex(Number(index))
            setIsFirstLoad(false)
        }, 100)
    }, [])

    // 每行可以展示多少个项目
    const calculateColumns = () => {
        const width = window.innerWidth;
        if (width >= 1800) return 6;
        if (width >= 1600) return 5;
        if (width >= 1200) return 4;
        return 3;
    };

    useEffect(() => {
        listProjectv2()
    }, [pageIndex, proOrder, proSortField, member])

    useEffect(() => {
        listBookmarkTaskv2()
    }, [member])

    useEffect(() => {
        if (!isFirstLoad) sessionStorage.removeItem('projectListPageIndex')
        setPageIndex(1)
        listProjectv2(1)
        listBookmarkTaskv2()
    }, [proSidebarValue, proFunction, projectName])

    const listBookmarkTaskv2 = async () => {
        const res = await commonApiInvoker(
            API.listBookmarkTaskv2({
                module: proSidebarValue,
                member: member == 'team' ? null : member ? member : globalUser?.id
            })
        )
        if (res.length > 0) {
            const image = res[0]?.results?.[0]?.image;
            if (image && (image.endsWith('.mp4') || image.endsWith('.MP4'))) {
                setBookCover(res[0]?.inputImage);
            } else {
                setBookCover(image);
            }
        } else {
            setBookCover()
        }
    }

    const listProjectv2 = (pageValue) => {
        let pageIndexCalc = calculateColumns() * 3 - 1
        commonApiInvoker(API.listProjectv2({
            pageIndex: pageValue ? pageValue : pageIndex,
            pageSize: pageIndexCalc,
            module: proSidebarValue,
            order: proOrder,
            sortField: proSortField,
            function: proFunction,
            projectName: projectName,
            member: member == 'team' ? null : member ? member : globalUser?.id
        })).then(res => {
            setList(res.items)
            setPageSize(res.pageSize)
            setTotal(res.total)
        })
    }

    const getIsSelected = (flag) => {
        setIsSelected(flag)
    }
    const selectCurrentItem = (id) => {
        if (selectedList.includes(id)) {
            setSelectedList(selectedList.filter(item => item !== id))
        } else {
            setSelectedList([...selectedList, id])
        }
    }

    const selectAll = () => {
        if (isSelectedAll) {
            setSelectedList([])
        } else {
            setSelectedList(list.map(item => item.id))
        }
    }

    const isSelectedAll = useMemo(() => {
        return list.length == selectedList.length
    }, [selectedList])

    const deleteClick = () => {
        if (selectedList.length == 0) return
        PSAIModal.confirm({
            title: "删除项目",
            content: "删除后项目将无法找回，确定删除吗？",
            onOk: deleteProject
        })
    }
    const deleteProject = () => {
        commonApiInvoker(API.projectBatchMove({
            ids: selectedList
        })).then(res => {
            message.success('删除成功');
            setSelectedList([])
            listProjectv2()
        })
    }

    const downClick = () => {
        if (selectedList.length == 0) return
        // const status = Utils.checkFirstDownLoad(() => downClickMeta())
        // if (!status) return
        downClickMeta()
    }

    const downClickMeta = () => {
        setDownLoading(true)
        commonApiInvoker(API.projectPatchDownload({
            ids: selectedList
        }), setDownLoading).then(res => {
            Utils.downloadFileWithToken(res).then(() => {
                message.success('下载成功');
            }).catch(() => {
                setDownLoading(false)
                message.warning('下载失败，请稍后重试');
            }).finally(() => {
                setDownLoading(false)
            })
        }).catch(() => {
            setDownLoading(false)
        }).finally(() => {
            setDownLoading(false)
        })
    }


    const pageCount = useMemo(() => {
        return false
    }, [list])


    return (
        <>
            <div className={styles.ProjectListPage} style={{ justifyContent: 'flex-start' }}>
                <ProListpageTop
                    getIsSelected={getIsSelected}
                    setSelectedList={setSelectedList}
                    selectedList={selectedList}
                    isSelectedAll={isSelectedAll}
                    downLoading={downLoading}
                    selectAll={selectAll}
                    downClick={downClick}
                    deleteClick={deleteClick}
                    tabKey={tabKey}
                    setMember={setMember}
                    member={member}
                />
                <div
                    className={`${styles.ProjectListItems} _beauty_scrollbar`}
                    style={{
                        padding: pageCount ? '60px 0' : '20px',
                    }}>
                    {
                        (globalOrgInfo?.current?.role == 'admin') &&
                        <Tabs items={items} activeKey={tabKey} onChange={tabChange} style={{ width: '100%' }} />
                    }
                    <div className={styles.ItemBox} >
                        <ProjectListItem
                            item={{
                                id: 'collect',
                                mainImage: bookCover || 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/collectPro.png',
                                projectName: tabKey == '1' ? '我的收藏' : '团队收藏'
                            }}
                            listProjectv2={listProjectv2}
                            isSelected={false} />
                    </div>


                    {
                        list.map((item) => (
                            <div
                                className={styles.ItemBox}
                                key={item.id}
                            >
                                <ProjectListItem
                                    item={item}
                                    listProjectv2={listProjectv2}
                                    isSelected={isSelected}
                                    selectedList={selectedList}
                                    selectCurrentItem={selectCurrentItem} />
                            </div>
                        ))
                    }
                </div>
                {
                    <div className={styles.ProjectListPagination}>
                        <Pagination
                            showQuickJumper
                            total={total}
                            onChange={onChange}
                            pageSize={pageSize}
                            current={pageIndex}
                            showSizeChanger={false} />
                    </div>
                }
            </div>
        </>

    )
}

export default ProjectListPage